import { Link as LinkIcon, MessageCircle, Youtube, Mail, ShoppingBag, Globe, Gift, CalendarDays, Send, Facebook, Mic, Headphones } from "lucide-react";
import { Compass, Feather, Crown, Gem, ShieldCheck, Sparkles, Star, Infinity as InfinityIcon, TrendingUp, Heart, Sun, Target } from "lucide-react";

export const VALUE_ICONS = {
  compass: Compass,
  feather: Feather,
  crown: Crown,
  gem: Gem,
  shield: ShieldCheck,
  sparkles: Sparkles,
  star: Star,
  infinity: InfinityIcon,
  trending: TrendingUp,
  heart: Heart,
  sun: Sun,
  target: Target,
};

export const VALUE_ICON_OPTIONS = Object.keys(VALUE_ICONS);

export const TikTokIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.6 6.7a4.8 4.8 0 0 1-3.8-4.2V2h-3.4v13.6a2.9 2.9 0 1 1-2-2.7V9.4a6.3 6.3 0 1 0 5.4 6.2V8.7a8.2 8.2 0 0 0 3.8 1.1V6.7z" />
  </svg>
);

export const InstagramIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className={className} aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const ThreadsIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z" />
  </svg>
);

// ---- Link-in-bio icons ----

export const LINK_ICONS = {
  link: LinkIcon,
  tiktok: TikTokIcon,
  instagram: InstagramIcon,
  threads: ThreadsIcon,
  whatsapp: MessageCircle,
  telegram: Send,
  youtube: Youtube,
  facebook: Facebook,
  email: Mail,
  shop: ShoppingBag,
  website: Globe,
  trading: TrendingUp,
  gift: Gift,
  booking: CalendarDays,
  star: Star,
  crown: Crown,
  diamond: Gem,
  podcast: Mic,
  audio: Headphones,
};

export const LINK_ICON_OPTIONS = Object.keys(LINK_ICONS);

export const normalizeUrl = (url = "") => {
  const u = url.trim();
  if (!u) return "";
  if (/^(https?:|mailto:|tel:)/i.test(u)) return u;
  if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(u)) return `mailto:${u}`;
  return `https://${u}`;
};
